<!-- name: '外链' -->
<template>
  <div class="backlinksWrap">
    <GoBack :title="title" />
    <iframe :src="link" width="100%" height="80%" frameborder="0"></iframe>
  </div>
</template>

<script>
import GoBack from "@/components/GoBack";
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    };
  },
  components: { GoBack },
  computed: {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
.backlinksWrap {
  height: 100%;
  width: 100%;
}
</style>